import React, { useState, useEffect } from "react";
import { Router, Route } from "react-router-dom";
import BonusReport from "./views/CPP/BonusReport/Bonus";
import "./custom.scss";
import {
  Details,
  CompensationRequest,
  Redeem,
  DetailsStatement,
} from "./views/CPP/Report";
import {
  Report,
  BonusTable,
  OMPRate,
  SpecialCondition,
  RecommendedPriceList,
  PriceList,
  WarrantyShipments,
} from "./views/CPP";
import { PublicRoute, PrivateRoute } from "./components/route";
import { history } from "./services/helpers/history";
import NotFound from "./views/Others";
import Home from "./views/Home";
import Orders from "./views/Compensation/Orders/Orders";
import ChannelRedeemStatements from "./views/Compensation/ChannelRedeem/ChannelRedeemStatements";
import ChannelRedeem from "./views/Compensation/ChannelRedeem/ChannelRedeem";
import { authenticationService } from "./services/context/AuthService";
import BonusPayment from "./views/Reports/BonusPayment/BonusPayment";
import SessionExpiredModal from './views/SessionExpired/SessionExpired';
import PriceListUploadTraining from "./views/Trainings/PriceListUploadTraining";
import CompensationPrices from "./views/Compensation/Prices/Prices";
import BalanceReport from "./views/Compensation/BalanceReport/BalanceReport";
import TPIReport from "./views/Reports/TPI/TPIReport";
import LoadingIndicator from "./common/LoadingIndicator/LoadingIndicator";
import Inventory from "./views/Inventory/Inventory";
import ContactUs from "./views/ContactUs/ContactUs";
import UserNotRegistered from "./views/UserNotRegistered/UserNotRegistered";
import { downloadFile } from "./services/FileDownloader/FileDownloader";
import UserInfoForm from "./views/UserInfoForm/UserInfoForm";
import InvalidIdentityProvider from "./views/InvalidIdentityProvider/InvalidIdentityProvider";
import SpecialConditionApproval from "./views/CPP/SpecialConditionApproval/SpecialConditionApproval";
import NewSpecialCondition from "./views/CPP/NewSpecialCondition/NewSpecialCondition";
import SpecialConditionReport from "./views/CPP/SpecialConditionApproval/SpecialConditionReport";
import Notification from "./views/Administration/Notification";
import EmailsSend from "./views/Administration/Emails";
import DataUpload from "./views/Administration/DataUpload";
import CPPComparison from "./views/Reports/CPPComparison/CPPComparison";
import GlobalAccountRender from "./views/Administration/RatesAndGlobalAccounts/GlobalAccountRender";
import RatesRender from "./views/Administration/RatesAndGlobalAccounts/RatesRender";
import RunLengthOldRender from "./views/Administration/RatesAndGlobalAccounts/RunLengthOldRender";
import RunLengthNewRender from "./views/Administration/RatesAndGlobalAccounts/RunLengthNewRender";
import LSMarkRender from "./views/Administration/RatesAndGlobalAccounts/LSMarkRender";
import FrameCoverageRender from "./views/Administration/RatesAndGlobalAccounts/FrameCoverageRender";
import VolumeAcceleration from "./views/Administration/VolumeAcceleration/VolumeAcceleration";
import pricelistbrazil from "./views/CPP/pricelistbrazil/pricelistbrazil";
import UserView from "./views/Administration/UserView/UserView";
import COIView from "./views/Administration/COIRegisterVIew/COIView";
import ManualAdjustment from "./views/Administration/ManualAdjustment/ManualAdjustment";
import Conci from "./views/Administration/conci";
import SpecialConditionLetter from "./views/CPP/SpecialConditionApproval/SpecialConditionLetter";
import ConfigConsumables from "./views/Inventory/configconsumables";
import SpecialConditionApproversView from "./views/Administration/SpecialConditionApproversView/SpecialConditionApproversView";
import SpecialConditionsProcess from "./views/CPP/SpecialConditionsProcess/SpecialConditionsProcess";
import NewSpecialConditionsProcess from "./views/CPP/SpecialConditionsProcess/NewSpecialConditionsProcess";
import PriceProtectionView from "./views/Administration/PriceProtection/PriceProtectionView";

import Evergreentables from "./views/Programs/evergreentables";
function App(props, { t }) {
  const pathName = window.location.pathname;
  const [authed, setauthed] = useState(null);
  const [loading, setLoading] = useState(true);
  const [firstTimeIn, setFirstTimeIn] = useState(false);
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);

  useEffect(() => {
    authenticationService.currentUser.subscribe((user) => {
      if (user?.email) {
        //Check if user's session should remain
        if (user.loginDate == undefined) {
          setLoading(false);
          setShowSessionExpiredModal(true);
        }
        else {
          const loginDate = new Date(user.loginDate);
          const currentDate = new Date();

          const loginDateDay = loginDate.getFullYear().toString() + (loginDate.getMonth() + 1).toString().padStart(2, '0') + loginDate.getDate().toString().padStart(2, '0');
          const currentDateDay = currentDate.getFullYear().toString() + (currentDate.getMonth() + 1).toString().padStart(2, '0') + currentDate.getDate().toString().padStart(2, '0');

          if (loginDateDay < currentDateDay) {
            setLoading(false);
            setShowSessionExpiredModal(true);
          } else {
            setauthed(true);
            setLoading(false);
            setFirstTimeIn(user.firstTimeIn);
            if (pathName.includes("FileDownload")) {
              downloadFile(window.location.href.split("#")[1]);
            }
          }
        }
      } else {
        if (!window.location.href.includes("userNotRegistered") && !window.location.href.includes("invalidIdentityProvider")) {
          authenticationService.loginOnHpId(setLoading);
        } else {
          setLoading(false);
        }
      }
    });
  }, []);

  return loading ? (
    <div>
      <LoadingIndicator />
    </div>
  ) : (
    showSessionExpiredModal ? (
      <SessionExpiredModal />
    ) : (
      
    <Router history={history}>
    <>
        <PublicRoute
            path="/userNotRegistered"
            auth={authed}
            firstTimeIn={firstTimeIn}
            component={UserNotRegistered}
            exact
        />
        <PublicRoute
            path="/invalidIdentityProvider"
            auth={authed}
            firstTimeIn={firstTimeIn}
            component={InvalidIdentityProvider}
            exact
        />
      <PublicRoute
        path="/userinfo"
        auth={authed}
        firstTimeIn={firstTimeIn}
        component={UserInfoForm}
        exact
      />
      <PrivateRoute
        path="/"
        auth={authed}
        firstTimeIn={firstTimeIn}
        component={Home}
        exact
      />
      <PrivateRoute
        path="/cpp/report"
        auth={authed}
        firstTimeIn={firstTimeIn}
        component={Report}
        exact
      />
      <PrivateRoute
        exact
        auth={authed}
        path="/cpp/report/statement/detail/:id/:idChannel"
        component={DetailsStatement}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/report/:id"
        component={Details}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/report/statement/order/:id"
        component={CompensationRequest}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/report/statement/redeem/:id/:idChannel/:idSerie"
        component={Redeem}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/compensation/orders"
        component={Orders}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/compensation/BalanceReport"
        component={BalanceReport}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/compensation/prices"
        component={CompensationPrices}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/Compensation/brazilprices"
        component={pricelistbrazil}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/compensation/ChannelRedeem"
        component={ChannelRedeemStatements}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/compensation/ChannelRedeem/:id"
        component={ChannelRedeem}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/reports/TpiReport"
        component={TPIReport}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/reports/BonusPayment"
        component={BonusPayment}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/BonusReport"
        component={BonusReport}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/BonusTable"
        component={BonusTable}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/OMPRate"
        component={OMPRate}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/RecommendedPriceListByHp"
        component={RecommendedPriceList}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/PriceList"
        component={PriceList}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/WarrantyShipments"
        component={WarrantyShipments}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/SpecialCondition"
        component={SpecialCondition}
       />

      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/SpecialConditionApproval"
        component={SpecialConditionApproval}
       />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/SpecialConditionReport"
        component={SpecialConditionReport}
       />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/SpecialConditionReport/:id"
        component={SpecialConditionReport}
       />
       
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/NewSpecialCondition"
        component={NewSpecialCondition}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/Inventory"
        component={Inventory}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/ContactUs"
        component={ContactUs}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/trainings/priceListUpload"
        component={PriceListUploadTraining}
      />

      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/notification"
        component={Notification}
      />

      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/emails"
        component={EmailsSend}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/DataUpload"
        component={DataUpload}
      />

      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/reports/CPPComparison"
        component={CPPComparison}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/GlobalAccountRender"
        component={GlobalAccountRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/RatesRender"
        component={RatesRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/RunLengthOldRender"
        component={RunLengthOldRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/RunLengthNewRender"
        component={RunLengthNewRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/LSMarkRender"
        component={LSMarkRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/FrameCoverageRender"
        component={FrameCoverageRender}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/VolumeAcceleration"
        component={VolumeAcceleration}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/UserView"
        component={UserView}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/COIView"
        component={COIView}
      />

      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/ManualAdjustment"
        component={ManualAdjustment}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/ManualAdjustment/:id"
        component={ManualAdjustment}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/Conciliation"
        component={Conci}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/cpp/SpecialConditionLetter"
        component={SpecialConditionLetter}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path='/conficonsu'
        component={ConfigConsumables}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/SpecialConditionApproversView"
        component={SpecialConditionApproversView}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/SpecialConditionsProcess"
        component={SpecialConditionsProcess}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/NewSpecialConditionsProcess"
        component={NewSpecialConditionsProcess}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/evergreentables"
        component={Evergreentables}
      />
      <PrivateRoute
        exact
        auth={authed}
        firstTimeIn={firstTimeIn}
        path="/PriceProtectionView"
        component={PriceProtectionView}
      />
      <Route path="/404" component={NotFound} exact />
    </>
  </Router>

    )
  );
}

export default App;